import { render, staticRenderFns } from "./RutePenyebrangan.vue?vue&type=template&id=4d58f771&scoped=true"
import script from "./RutePenyebrangan.vue?vue&type=script&lang=js"
export * from "./RutePenyebrangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58f771",
  null
  
)

export default component.exports